module.exports = __webpack_public_path__ + "static/img/service_passprime_credit.25599fc9.png";